// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Chatbot {
        display: flex;
        flex-direction: column;

        gap: 5px;

        width: 350px;
        padding: 10px;

        position: absolute;

        bottom: 5px;
        right: 5px;

        overflow: hidden;

        pointer-events: none;
}

.Chatbot_bgGrad {
        padding: 4px;
        background: linear-gradient(to right, #A14B51, #864ba1);

        display: flex;
        flex-direction: column;
        flex-grow: 1;

        overflow: hidden;

        border-radius: 14px;

        box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;

        position: relative;
        z-index: 1;

        pointer-events: all;
}

.Chatbot_window {
        border-radius: 10px;
        overflow: hidden;

        position: relative;
        z-index: 1;

        background-color: #F7F8FB;
}

.Chatbot_header {
        height: 50px;
        background-color: #fff;
        box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;

        display: flex;
        align-items: center;
        padding: 0 15px;

        gap: 15px;

        z-index: 1;

        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
}

.Chatbot_header_title {
        font-size: 16px;
        font-weight: 800;
        color: #fff;
}

.Chatbot_header > img:first-child {
        height: 30px;
}

.Chatbot_header > img:last-child {
        height: 25px;
        margin-left: auto;
        cursor: pointer;
}

.Chatbot_messages {
        height: 150px;

        overflow-y: auto;

        display: flex;
        flex-direction: column;

        gap: 20px;

        padding: 15px;

        /* justify-content: flex-end; */
}

.Chatbot_message {
        overflow: hidden;

        display: inline-flex;
        flex-direction: column;
        flex-shrink: 0;

        font-size: 12px;

        background-color: #FFFFFF;
        box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;

        padding: 15px;
        border-radius: 20px;
        border-top-left-radius: 0;

        color: #000;
        font-weight: 600;
}

.Chatbot_message:first-child {
        margin-top: auto;
}

.Chatbot_message:nth-child(even) {
        background: linear-gradient(to right, #A14B51, #864ba1);

        border-top-left-radius: 20px;
        border-bottom-right-radius: 0;

        color: #fff;

        margin-left: auto;
}

.Chatbot_input {
        display: flex;

        justify-content: space-between;

        padding: 10px;

        gap: 10px;

        box-shadow: rgba(17, 17, 26, 0.05) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px;

        z-index: 1;

        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
}

.Chatbot_inputBox {
        width: 290px;

        font-size: 12px;

        border: none;
        outline: none;
        border-radius: 20px;

        box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;

        padding: 0 12.5px;
}

.Chatbot_submit {
        border: none;
        border-radius: 50%;
        background-color: transparent;
        box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
        padding: 0;

        display: flex;
        align-items: center;
        justify-content: center;

        cursor: pointer;
}

.Chatbot_submit > img {
        height: 30px;
}

.Chatbot_button_container {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        flex-shrink: 0;

        height: 50px;
        width: 100%;
}

.Chatbot_button {
        height: 100%;
        aspect-ratio: 1;
        background-color: #fff;
        border: 1px solid #e4e4e4;
        border-radius: 50%;

        box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);

        pointer-events: all;
        cursor: pointer;
}

.Chatbot_icon {
        height: 30px;
}
`, "",{"version":3,"sources":["webpack://./src/components/ChatBot/Chatbot.css"],"names":[],"mappings":"AAAA;QACQ,aAAa;QACb,sBAAsB;;QAEtB,QAAQ;;QAER,YAAY;QACZ,aAAa;;QAEb,kBAAkB;;QAElB,WAAW;QACX,UAAU;;QAEV,gBAAgB;;QAEhB,oBAAoB;AAC5B;;AAEA;QACQ,YAAY;QACZ,uDAAuD;;QAEvD,aAAa;QACb,sBAAsB;QACtB,YAAY;;QAEZ,gBAAgB;;QAEhB,mBAAmB;;QAEnB,2CAA2C;;QAE3C,kBAAkB;QAClB,UAAU;;QAEV,mBAAmB;AAC3B;;AAEA;QACQ,mBAAmB;QACnB,gBAAgB;;QAEhB,kBAAkB;QAClB,UAAU;;QAEV,yBAAyB;AACjC;;AAEA;QACQ,YAAY;QACZ,sBAAsB;QACtB,qFAAqF;;QAErF,aAAa;QACb,mBAAmB;QACnB,eAAe;;QAEf,SAAS;;QAET,UAAU;;QAEV,4BAA4B;QAC5B,6BAA6B;AACrC;;AAEA;QACQ,eAAe;QACf,gBAAgB;QAChB,WAAW;AACnB;;AAEA;QACQ,YAAY;AACpB;;AAEA;QACQ,YAAY;QACZ,iBAAiB;QACjB,eAAe;AACvB;;AAEA;QACQ,aAAa;;QAEb,gBAAgB;;QAEhB,aAAa;QACb,sBAAsB;;QAEtB,SAAS;;QAET,aAAa;;QAEb,+BAA+B;AACvC;;AAEA;QACQ,gBAAgB;;QAEhB,oBAAoB;QACpB,sBAAsB;QACtB,cAAc;;QAEd,eAAe;;QAEf,yBAAyB;QACzB,qFAAqF;;QAErF,aAAa;QACb,mBAAmB;QACnB,yBAAyB;;QAEzB,WAAW;QACX,gBAAgB;AACxB;;AAEA;QACQ,gBAAgB;AACxB;;AAEA;QACQ,uDAAuD;;QAEvD,4BAA4B;QAC5B,6BAA6B;;QAE7B,WAAW;;QAEX,iBAAiB;AACzB;;AAEA;QACQ,aAAa;;QAEb,8BAA8B;;QAE9B,aAAa;;QAEb,SAAS;;QAET,iFAAiF;;QAEjF,UAAU;;QAEV,+BAA+B;QAC/B,gCAAgC;AACxC;;AAEA;QACQ,YAAY;;QAEZ,eAAe;;QAEf,YAAY;QACZ,aAAa;QACb,mBAAmB;;QAEnB,qFAAqF;;QAErF,iBAAiB;AACzB;;AAEA;QACQ,YAAY;QACZ,kBAAkB;QAClB,6BAA6B;QAC7B,qFAAqF;QACrF,UAAU;;QAEV,aAAa;QACb,mBAAmB;QACnB,uBAAuB;;QAEvB,eAAe;AACvB;;AAEA;QACQ,YAAY;AACpB;;AAEA;QACQ,aAAa;QACb,mBAAmB;QACnB,yBAAyB;QACzB,cAAc;;QAEd,YAAY;QACZ,WAAW;AACnB;;AAEA;QACQ,YAAY;QACZ,eAAe;QACf,sBAAsB;QACtB,yBAAyB;QACzB,kBAAkB;;QAElB,wCAAwC;;QAExC,mBAAmB;QACnB,eAAe;AACvB;;AAEA;QACQ,YAAY;AACpB","sourcesContent":[".Chatbot {\n        display: flex;\n        flex-direction: column;\n\n        gap: 5px;\n\n        width: 350px;\n        padding: 10px;\n\n        position: absolute;\n\n        bottom: 5px;\n        right: 5px;\n\n        overflow: hidden;\n\n        pointer-events: none;\n}\n\n.Chatbot_bgGrad {\n        padding: 4px;\n        background: linear-gradient(to right, #A14B51, #864ba1);\n\n        display: flex;\n        flex-direction: column;\n        flex-grow: 1;\n\n        overflow: hidden;\n\n        border-radius: 14px;\n\n        box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n\n        position: relative;\n        z-index: 1;\n\n        pointer-events: all;\n}\n\n.Chatbot_window {\n        border-radius: 10px;\n        overflow: hidden;\n\n        position: relative;\n        z-index: 1;\n\n        background-color: #F7F8FB;\n}\n\n.Chatbot_header {\n        height: 50px;\n        background-color: #fff;\n        box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;\n\n        display: flex;\n        align-items: center;\n        padding: 0 15px;\n\n        gap: 15px;\n\n        z-index: 1;\n\n        border-top-left-radius: 10px;\n        border-top-right-radius: 10px;\n}\n\n.Chatbot_header_title {\n        font-size: 16px;\n        font-weight: 800;\n        color: #fff;\n}\n\n.Chatbot_header > img:first-child {\n        height: 30px;\n}\n\n.Chatbot_header > img:last-child {\n        height: 25px;\n        margin-left: auto;\n        cursor: pointer;\n}\n\n.Chatbot_messages {\n        height: 150px;\n\n        overflow-y: auto;\n\n        display: flex;\n        flex-direction: column;\n\n        gap: 20px;\n\n        padding: 15px;\n\n        /* justify-content: flex-end; */\n}\n\n.Chatbot_message {\n        overflow: hidden;\n\n        display: inline-flex;\n        flex-direction: column;\n        flex-shrink: 0;\n\n        font-size: 12px;\n\n        background-color: #FFFFFF;\n        box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;\n\n        padding: 15px;\n        border-radius: 20px;\n        border-top-left-radius: 0;\n\n        color: #000;\n        font-weight: 600;\n}\n\n.Chatbot_message:first-child {\n        margin-top: auto;\n}\n\n.Chatbot_message:nth-child(even) {\n        background: linear-gradient(to right, #A14B51, #864ba1);\n\n        border-top-left-radius: 20px;\n        border-bottom-right-radius: 0;\n\n        color: #fff;\n\n        margin-left: auto;\n}\n\n.Chatbot_input {\n        display: flex;\n\n        justify-content: space-between;\n\n        padding: 10px;\n\n        gap: 10px;\n\n        box-shadow: rgba(17, 17, 26, 0.05) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px;\n\n        z-index: 1;\n\n        border-bottom-left-radius: 10px;\n        border-bottom-right-radius: 10px;\n}\n\n.Chatbot_inputBox {\n        width: 290px;\n\n        font-size: 12px;\n\n        border: none;\n        outline: none;\n        border-radius: 20px;\n\n        box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;\n\n        padding: 0 12.5px;\n}\n\n.Chatbot_submit {\n        border: none;\n        border-radius: 50%;\n        background-color: transparent;\n        box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;\n        padding: 0;\n\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        cursor: pointer;\n}\n\n.Chatbot_submit > img {\n        height: 30px;\n}\n\n.Chatbot_button_container {\n        display: flex;\n        align-items: center;\n        justify-content: flex-end;\n        flex-shrink: 0;\n\n        height: 50px;\n        width: 100%;\n}\n\n.Chatbot_button {\n        height: 100%;\n        aspect-ratio: 1;\n        background-color: #fff;\n        border: 1px solid #e4e4e4;\n        border-radius: 50%;\n\n        box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);\n\n        pointer-events: all;\n        cursor: pointer;\n}\n\n.Chatbot_icon {\n        height: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
